import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { lenis, scrollTo } from './lenis'
import { initFormModal } from './modal'

gsap.registerPlugin(ScrollTrigger)

export const initSprig = () => {

	let el = document.querySelector('[data-sprig-container]')
	let entries = document.querySelector('[data-sprig-entries]')

	if (!el || !entries) return

	htmx.on('htmx:beforeRequest', (e) => {
		el = document.querySelector('[data-sprig-container]')
		entries = document.querySelector('[data-sprig-entries]')

		gsap.to(entries, {
			duration: 0.35,
			opacity: 0,
			onComplete: () => {
			}
		})
		lenis.scrollTo(el, {
			duration: 1.5,
			offset: -100
		})
	})

	htmx.on('htmx:afterSwap', () => {
		entries = document.querySelector('[data-sprig-entries]')

		gsap.fromTo(entries, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.35
		})

		initFormModal()
	})
}

export default () => {} 